import React from 'react';

function PopupTitle({ text }) {
  return (
    <div className='cpt-top-title'>
      <p className='cpt-title-pp'>{text}</p>
    </div>
  );
}
export default PopupTitle;
